"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var certificate_controller_1 = __importDefault(require("./certificate.controller"));
var certificate_html_1 = __importDefault(require("./certificate.html"));
function getStudent($stateParams, UsersModel) {
    return UsersModel.getStudentByID($stateParams.userId).then(function (response) {
        return response;
    });
}
getStudent.$inject = ["$stateParams", "UsersModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.certificate", {
        url: "/certificate",
        controller: certificate_controller_1.default,
        controllerAs: "vm",
        template: certificate_html_1.default,
        resolve: {
            student: getStudent,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.certificate", [])
    .config(config)
    .controller("AdminStudentViewCertificateController", certificate_controller_1.default);
